import { TICKET_DETAILS, PASSENGER_DETAILS } from "../actions/action-types.js";
import lodashCloneDeep from "lodash/cloneDeep";

const initialState = {
  ticketdetails: {},
  dropping: {},
  boarding: {},
  passengerdetails: {},
  totalamount: null,
  bus: {},
  email: "",
  mobile: ""
};

const ticketdetailsReducer = (state = initialState, action) => {
  let newState = null;
  switch (action.type) {
    case TICKET_DETAILS:
      newState = lodashCloneDeep(state);
      newState.ticketdetails = action.payload.ticketdetails;
      newState.boarding = action.payload.boarding;
      newState.dropping = action.payload.dropping;
      newState.bus = action.payload.bus;
      newState.totalamount = action.payload.totalamount;
      return newState;

    case PASSENGER_DETAILS:
      newState = lodashCloneDeep(state);
      if (action.payload.passengerdetails) {
        newState.passengerdetails = action.payload.passengerdetails;
      }
      if (action.payload.email || action.payload.email === "") {
        newState.email = action.payload.email;
      }
      if (action.payload.mobile || action.payload.mobile === "") {
        newState.mobile = action.payload.mobile;
      }
      return newState;

    default:
      return state;
  }
};

export default ticketdetailsReducer;
